export default __webpack_public_path__ + "assets/images/pricing/e7cf77158a8452b8d3c05ce2379a91e6.png";